<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card>
		<v-card-title>
			<h2>Dziennik audytu</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<br/>
		
		<v-layout align-center justify-center row wrap>
            <v-flex xs12 sm6 md2>
				<v-autocomplete
					ref="userAutocomplete"
					class="ma-2"
					:items="dataTable.users"
					label="Użytkownik"
					aria-label="user"
					for="audit-log-view-agency-user"
					id="audit-log-view-agency-user"
					item-text="email"
					item-value="id"
					v-model="dataTable.searchFields.userId"
					@keyup="loadUsers"
					:no-filter="true"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs12 sm6 md2>
				<v-autocomplete
					ref="moduleAutocomplete"
					class="ma-2"
					:items="dataTable.modules"
					label="Moduł"
					aria-label="module"
					item-text="name"
					item-value="code"
					v-model="dataTable.searchFields.moduleCode"
					@change="onModuleChange"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs12 sm6 md2>
				<v-autocomplete
					ref="actionAutocomplete"
					:class="['ma-2', { 'grayed-out': !dataTable.searchFields.moduleCode }]"
					:items="dataTable.actions"
					label="Akcja"
					aria-label="action"
					item-text="name"
					item-value="code"
					v-model="dataTable.searchFields.actionCode"
					:readonly="!dataTable.searchFields.moduleCode"
					clearable
				></v-autocomplete>
			</v-flex>
			<v-flex xs12 sm6 md1>
				<EgrantyDatePicker
					class="ma-2"
					label="Data od"
					v-model="dataTable.searchFields.fromDate"
				></EgrantyDatePicker>
			</v-flex>
			<v-flex xs12 sm6 md1>
				<EgrantyDatePicker
					class="ma-2"
					label="Data do"
					v-model="dataTable.searchFields.toDate"
				></EgrantyDatePicker>
			</v-flex>
			<v-flex xs12 sm6 md2>
				<v-layout align-end justify-start row class="pb-2">
					<v-btn @click="buildNewSearch" color="primary" dark class="ml-4">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark>Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="mr-3">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1">
			<template slot="items" slot-scope="props">
				<td class="text-xs-left">{{ props.item.userEmail ? props.item.userEmail :  'Użytkownik niezalogowany'}}</td>
				<td class="text-xs-left">{{ props.item.module }}</td>
				<td class="text-xs-left">{{ props.item.actionInfo }}</td>
				<td class="text-xs-left">{{ props.item.actionAt }}</td>
				<td class="text-xs-left">{{ props.item.deviceCode }}</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {Pagination} from "@/utils/PaginationUtils";
	import {Filters} from "@/utils/Filters";
    import {Audit} from "../../../api/generated/Audit";
	import EgrantyDatePicker from "../../../genericComponents/EgrantyDatePicker";

	export default {
		name: "AuditLogView",

		components: {
			EgrantyDatePicker
		},

		mixins: [Filters],

		watch: {
			"dataTable.pagination": {
				handler(pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			}
		},

		data() {
			return {
				dataTable: {
					searchFields: Pagination.initSearchedFields([
						"module",
						"userId",
						"moduleCode",
						"actionCode",
						"fromDate",
						"toDate"
					]),
					tableHeaders: [
						{
							text: "Użytkownik",
							sortable: true,
							value: "userEmail"
						},
						{
							text: "Moduł",
							sortable: true,
							value: "module"
						},
						{
							text: "Akcja",
							sortable: true,
							value: "actionInfo"
						},
						{
							text: "Data",
							sortable: true,
							value: "actionAt"
						},
						{
							text: "Urządzenie",
							sortable: true,
							value: "deviceCode"
						}
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25,
						sortBy: null
					},
					search: "",
                    users: [],
                    modules: [],
                    actions: []
				}
			};
		},

		methods: {
            loadUsers(event) {
                const searchText = event.target ? event.target.value : event;
                if (searchText && searchText.length === 1) {
                    return;
                }
                
                Audit.getUsers(this, searchText, successResponse => {
                    this.dataTable.users = successResponse;
                    
                    // Przywracamy focus po aktualizacji listy tylko jeśli to był event z inputu
                    if (event.target) {
                        this.$nextTick(() => {
                            if (this.$refs.userAutocomplete) {
                                this.$refs.userAutocomplete.focus();
                            }
                        });
                    }
                },
                errorResponse => {
                    this.$messagesBus.$emit("error", "Nie udało się pobrać listy użytkowników", errorResponse);
                }, { ignoreLoader: true });
			},
			loadModules(event) {
               
                
                Audit.getModules(this, successResponse => {
                    this.dataTable.modules = successResponse;
                    
                    // Przywracamy focus po aktualizacji listy tylko jeśli to był event z inputu
                    if (event.target) {
                        this.$nextTick(() => {
                            if (this.$refs.moduleAutocomplete) {
                                this.$refs.moduleAutocomplete.focus();
                            }
                        });
                    }
                },
                errorResponse => {
                    this.$messagesBus.$emit("error", "Nie udało się pobrać listy modułów", errorResponse);
                }, { ignoreLoader: true });
			},
			loadActions(event) {
                
                if (!this.dataTable.searchFields.moduleCode) {
                    this.dataTable.actions = [];
                    return;
                }
                
                Audit.getActions(this, this.dataTable.searchFields.moduleCode, successResponse => {
                    this.dataTable.actions = successResponse;
                    
                    // Przywracamy focus po aktualizacji listy tylko jeśli to był event z inputu
                    if (event.target) {
                        this.$nextTick(() => {
                            if (this.$refs.actionAutocomplete) {
                                this.$refs.actionAutocomplete.focus();
                            }
                        });
                    }
                },
                errorResponse => {
                    this.$messagesBus.$emit("error", "Nie udało się pobrać listy akcji", errorResponse);
                }, { ignoreLoader: true });
			},
			onModuleChange() {
				// Wyczyść wybraną akcję gdy zmieni się moduł
				this.dataTable.searchFields.actionCode = undefined;
				// Załaduj akcje dla nowego modułu
				if (this.dataTable.searchFields.moduleCode) {
					this.loadActions('');
				} else {
					this.dataTable.actions = [];
				}
			},
			exportData () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				let path = "/audit/export?" + this.dataTable.search
        + "&page=" + this.dataTable.pagination.page
        + "&itemsPerPage=" + this.dataTable.pagination.rowsPerPage
        + ((this.dataTable.pagination.sortBy) 
            ? "&sortBy=" + this.dataTable.pagination.sortBy 
              + ((this.dataTable.pagination.descending != null) 
                 ? "&sortDesc=" + this.dataTable.pagination.descending 
                 : "") 
            : "");
				ExportUtils.sendExportCsvRequest(path, this);
			},

			getItemList() {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				const url = "/audit/logs?" + this.dataTable.search
        + "&page=" + this.dataTable.pagination.page
        + "&itemsPerPage=" + this.dataTable.pagination.rowsPerPage
        + ((this.dataTable.pagination.sortBy) 
            ? "&sortBy=" + this.dataTable.pagination.sortBy 
              + ((this.dataTable.pagination.descending != null) 
                 ? "&sortDesc=" + this.dataTable.pagination.descending 
                 : "") 
            : "");

    Api.get(this, url, response => {
        this.dataTable.itemList = response.result;
        this.dataTable.itemCount = response.total;
    });	
			},

			buildNewSearch() {
				this.dataTable.search = this.buildSearch();
				this.getItemList();
			},

			resetSearch() {
				Pagination.resetSearch(this.dataTable.searchFields);
				this.getItemList();
			},

			buildSearch() {
				return Pagination.buildAuditSearchCriteria(this.dataTable.searchFields);
			},
		},

		created () {
      this.loadUsers('');
      this.loadModules('');
		},
	};
</script>

<style scoped>
.grayed-out {
	opacity: 0.6;
	pointer-events: none;
}
</style>
